import React, { Component } from 'react';
import { Button, Pagination } from 'react-bootstrap';

class PaginationComp extends Component {



  jumpTo(pageNo) {
    let data = {
      pageNo: pageNo,
      pageSize: 10
    }
    this.props.getInfo(data);
  }



  render() {
    const { currentPage } = this.props;
    let selectedOption = <React.Fragment>
      {(currentPage - 2 <= 1) ?
        <Pagination.Item disabled>..</Pagination.Item>
        :
        <Pagination.Item onClick={() => this.jumpTo(currentPage - 2)}>{currentPage - 2}</Pagination.Item>
      }
      {(currentPage - 2 <= 1) ?
        <Pagination.Item disabled>..</Pagination.Item>
        :
        <Pagination.Item onClick={() => this.jumpTo(currentPage - 1)}>{currentPage - 1}</Pagination.Item>
      }
      <Pagination.Item active>{currentPage}</Pagination.Item>
      {(currentPage + 1 <= this.props.lastPage) ?
        <Pagination.Item onClick={() => this.jumpTo(currentPage + 1)}>{currentPage + 1}</Pagination.Item>
        :
        <Pagination.Item disabled>..</Pagination.Item>
      }
      {(currentPage + 2 <= this.props.lastPage) ?
        <Pagination.Item onClick={() => this.jumpTo(currentPage + 2)}>{currentPage + 2}</Pagination.Item>
        :
        <Pagination.Item disabled>..</Pagination.Item>
      }
    </React.Fragment>

    return (
      <Pagination>
        <Pagination.First disabled={(currentPage == 1) ? true : false} onClick={() => this.jumpTo(1)} />
        <Pagination.Prev disabled={(currentPage - 1 == 0) ? true : false} onClick={() => this.jumpTo(currentPage - 1)} />
        {selectedOption}
        <Pagination.Next disabled={(currentPage + 1 >= this.props.lastPage) ? true : false} onClick={() => this.jumpTo(currentPage + 1)} />
        <Pagination.Last disabled={(currentPage == this.props.lastPage) ? true : false} onClick={() => this.jumpTo(this.props.lastPage)} />
      </Pagination>
    )
  }
}


export default PaginationComp;